import styled from 'styled-components'

export const Container = styled.thead`
  background-color: ${props => props.theme.colors.background.secondary};
  border-color: ${props => props.theme.colors.background.secondary};
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 1;

  th:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  th:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  th {
    color: ${props => props.theme.colors.text.subtle};
    text-transform: uppercase;
    padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
    align-items: end;
  }
`
